import {baseDeleteRequest} from "../base/baseDeleteRequest";

const deleteSession = () => baseDeleteRequest(`/session/`);

export default deleteSession;
